import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class modReferralsReport_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `


            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                </div>
            </div>

            <div class="list-header w-justify" >

                <div class="w-center">
                        ` + this.filter.getHtmlBuild() + `
                </div>

                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'displayName') }, css: { 'list-sort-desc': orderByAndDirection()=='displayName_DESC', 'list-sort-asc': orderByAndDirection()=='displayName_ASC' }">Display Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idProfile') }, css: { 'list-sort-desc': orderByAndDirection()=='idProfile_DESC', 'list-sort-asc': orderByAndDirection()=='idProfile_ASC' }">idProfile</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'loginName') }, css: { 'list-sort-desc': orderByAndDirection()=='loginName_DESC', 'list-sort-asc': orderByAndDirection()=='loginName_ASC' }">Email</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'referredBy') }, css: { 'list-sort-desc': orderByAndDirection()=='referredBy_DESC', 'list-sort-asc': orderByAndDirection()=='referredBy_ASC' }">Referred By</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalRefers') }, css: { 'list-sort-desc': orderByAndDirection()=='totalRefers_DESC', 'list-sort-asc': orderByAndDirection()=='totalRefers_ASC' }">Total Refers</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: referrals">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: displayName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: idProfile || '-'"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: loginName"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: referredBy || '-'"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }" ><a class="right-click"><span data-bind="text: totalRefers"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string {
        return "modReferralsReport_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("displayName")
            , orderByDirection: ko.observable("ASC")
            , referrals: ko.observableArray([])
            , orderByAndDirection: ko.observable("displayName_ASC")
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickView: function (data) {
                huit_neuf_this.onClickView(data);
            }
        };
    }

    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword
            },
        };
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public setViewModelFromRequest(urlParams) {

        if (urlParams == null) {
            return;
        }

        let keywordString = urlParams.keywords;
        if (urlParams.keywords) {
            keywordString = urlParams.keywords.replaceAll("+", " ");
        }

        this.filter.getTemplateViewModel().filterKeyword(keywordString);
    }

    public setReferrals(data) {

        this.getTemplateViewModel().referrals(data);
    }

    public onClickView(data) {

        this.caller.view(data);
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/modReferralsReport_template.ts